export const TRIAL_LIFECYCLE_CONFLICT_REASON = {
  STALE_EXTERNAL_AFTER_PORTAL_UPDATE: 'stale_external_after_portal_update',
  DUPLICATE_OR_OUT_OF_ORDER_EXTERNAL: 'duplicate_or_out_of_order_external',
  EXTERNAL_UPDATE_BLOCKED: 'external_update_blocked',
} as const;

export type TrialLifecycleConflictReason =
  (typeof TRIAL_LIFECYCLE_CONFLICT_REASON)[keyof typeof TRIAL_LIFECYCLE_CONFLICT_REASON];

export interface TrialLifecycleConflict {
  reason: TrialLifecycleConflictReason | string;
  detectedAt: string;
  source: string;
  details?: string;
}

export interface TrialLifecycleStateContract {
  trialId: string;
  studioId: string;
  studentName: string | null;
  className: string | null;
  appointmentStatus: string | null;
  attendance: {
    isPresent: boolean | null;
    label: 'present' | 'absent' | 'unknown';
  };
  schedule: {
    startTime: string | null;
    endTime: string | null;
    cancelledAt: string | null;
  };
  lifecycleConflict: {
    hasConflict: boolean;
    reason: TrialLifecycleConflictReason | string | null;
    detectedAt: string | null;
    details: string | null;
  };
  updatedAt: string | null;
}
